import React from 'react';
import { Camera } from 'lucide-react';

/** Credit stamp on hero photos - survives a screenshot, unlike a caption. */
const PhotoCredit = ({ label }) => (
  <span
    data-testid="hero-photo-credit"
    className="pointer-events-none select-none absolute top-3 right-3 lg:top-5 lg:right-6 z-10
               inline-flex items-center gap-1.5 rounded-sm bg-black/65 backdrop-blur-[2px]
               border border-white/15 px-2 py-1
               text-[9px] sm:text-[10px] font-black uppercase tracking-[0.18em] text-white/85"
  >
    <Camera className="h-3 w-3 text-red-400" />
    {label || 'Photo: Outlaw Media'}
  </span>
);

export default PhotoCredit;
